module.exports = __webpack_public_path__ + "static/img/message_icon@3x.d1aaf86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message_icon@3x.png
// module id = tLQo
// module chunks = 1